import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { breakpoints } from 'Components/ThemeProvider';

import useMedia from 'utils/useMedia';

const StyledLink = styled.a`
  color: ${theme.colors.primary[400]};
  border-bottom: ${props => (props.isActive ? `2px solid ${theme.colors.accent[300]}` : 'none')};
  font-weight: ${props => (props.isActive ? 'bold' : 'normal')};
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s ease-in;
  padding: 0;

  &:focus {
    outline: none;
  }
`;
const SecondaryNavBarLink = ({ link, scrollMarginTop }) => {
  const ref = useRef();
  const isMobile = useMedia(`(max-width: ${breakpoints.sm}px)`);
  const defaultHash = useLocation().hash.substring(1);
  const hasPathHash = defaultHash.length;

  const scrollToSection = (anchor = link.id) => {
    const el = document.querySelector(`#${anchor}`);
    if (el) {
      el.style.scrollMarginTop = scrollMarginTop;
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (hasPathHash) {
      setTimeout(() => {
        scrollToSection(defaultHash);
      }, 100);
    }
  }, []);

  useEffect(() => {
    const id = setTimeout(() => {
      if (isMobile && link.isActive) {
        ref.current.focus();
      }
    }, 500);

    return () => {
      clearTimeout(id);
    };
  }, [isMobile, link.isActive]);

  return (
    <StyledLink
      ref={ref}
      data-click={link.dataClick}
      data-from="secondary-nav"
      data-testid={`link_${link.testId}`}
      href={`#${link.id}`}
      isActive={link.isActive}
      onClick={() => scrollToSection()}
    >
      {link.label}
    </StyledLink>
  );
};

SecondaryNavBarLink.defaultProps = {
  scrollMarginTop: '0',
};

SecondaryNavBarLink.propTypes = {
  link: PropTypes.shape({
    testId: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    isActive: PropTypes.bool,
    dataClick: PropTypes.string,
  }).isRequired,
  scrollMarginTop: PropTypes.string,
};

export default SecondaryNavBarLink;
